type AdditionalInformationsProps = {
  title: string;
  content: string;
};

import styles from "./AdditionalInformation.module.scss";

export const AdditionalInformation = ({
  title,
  content,
}: AdditionalInformationsProps) => {
  return (
    <div className={styles.additionalInformationBlock}>
      <div>
        <p className={styles.additionalInformationsTitle}>{title}</p>
        <p>{content}</p>
      </div>
    </div>
  );
};
